'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import appConstants from 'constants/appConstants';

import personActions from 'actions/PersonActionCreators';
import PageSection from 'components/base/PageSection';
import List from 'components/base/list-components/List';
import ListItem from 'components/base/list-components/ListItem';
import ListSection from 'components/base/list-components/ListSection';
import classNames from 'classnames';
import Tag from 'components/base/Tag';

import utils from 'services/utils';
import moment from 'moment';
import 'styles/LeaveApplication.scss';

const propTypes = {
    id: PropTypes.string,
};

const upcomingLabel = 'Upcoming';

class NextLeaveWidget extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
            
        var model = {
            Name: upcomingLabel,
            PageNumber: 1,
            RecordsPerPage: 1,
            LeaveStatusList: [
                appConstants.ENUMS.LEAVE_STATUS.PENDING, 
                appConstants.ENUMS.LEAVE_STATUS.APPROVED, 
                appConstants.ENUMS.LEAVE_STATUS.IN_APPROVAL,
            ],
            StartDate: moment().format(appConstants.dates.formats.SERVER_POST_FORMAT),
            SortingType: 0,
            IsSortingDesc: false,
        };

        setTimeout(function () {
            personActions.getSinglePersonLeave(this.props.person.Id, model);     
        }.bind(this), 0);
    }

    render() {

        var initialLoading = false;
        var backgroundColor = null;
        var nextLeaveContent = [];
        var link = "";
        var error = null;
        var heading = "Next Leave";

        if (this.props.person && this.props.person.Id && this.props.person.leaveApplications && this.props.person.leaveApplications[upcomingLabel] && this.props.person.leaveApplications[upcomingLabel].applications) {
            link = "/members/" + this.props.person.Id + "/leave/";

            if (this.props.person.leaveApplications[upcomingLabel].applications.length > 0) {
                var app = this.props.person.leaveApplications[upcomingLabel].applications[0];

                var startDate = moment.utc(app.StartDate);
                var endDate = moment.utc(app.EndDate);

                var daysDiff = null;
                if (startDate.isSame(endDate)) {
                    daysDiff = '1 day';
                } else {
                    daysDiff = '{0} days'.format(endDate.diff(startDate, 'days') + 1);
                }

                backgroundColor = app.LeaveReason.LeaveType.ColorName;
                const leaveConfigOption = this.props.configOptionsManager.getOption("leave", this.props.person.ApiKey);

                var statusClasses = classNames(
                    'status-tag', {
                        'status-approved': app.LeaveStatusLabel === appConstants.ENUMS.LEAVE_STATUS_LABELS.APPROVED,
                        'status-submitted': (app.LeaveStatusLabel === appConstants.ENUMS.LEAVE_STATUS_LABELS.PENDING_APPROVAL || 
                            app.LeaveStatusLabel === appConstants.ENUMS.LEAVE_STATUS_LABELS.IN_APPROVAL ||
                            app.LeaveStatusLabel === appConstants.ENUMS.LEAVE_STATUS_LABELS.PENDING_CANCELLATION_APPROVAL ||
                            app.LeaveStatusLabel === appConstants.ENUMS.LEAVE_STATUS_LABELS.CANCELLATION_INAPPROVAL),
                        'status-cancelled': app.LeaveStatusLabel === appConstants.ENUMS.LEAVE_STATUS_LABELS.CANCELLED,
                        'status-declined': app.LeaveStatusLabel === appConstants.ENUMS.LEAVE_STATUS_LABELS.DECLINED,
                    }
                );

                var content = (
                    <div className="la-content">
                        <div className="data">
                            <span className="label">Duration</span><span>{daysDiff}</span><br />
                            <span className="label">Reason/Entitlement</span><span>{app.LeaveReason.LeaveType.Label === app.LeaveReason.Name ? app.LeaveReason.Name : app.LeaveReason.Name + "/" + app.LeaveReason.LeaveType.Label}</span><br />
                            <span className="label">Leave Hours</span><span>{Math.abs(app.TotalHours)}</span>
                        </div>
                    </div>
                );
                nextLeaveContent.push(
                    <ListItem key="0" className="la colored-background" style={{backgroundColor}}
                        avatar={(
                            <div className="doughnut">
                                <i className={app.LeaveReason.LeaveType.IconName + "-small"} />                    
                            </div>
                        )}
                        heading={(
                            <span>
                                {utils.getLeaveDateRangeFormat(app, leaveConfigOption)}
                                <Tag 
                                    label={app.LeaveStatusLabel}
                                    className={statusClasses}
                                />
                            </span>
                        )}
                        content={content}
                        multiline
                    />
                );

            
            } else {

                nextLeaveContent.push(
                    <ListItem key="0" content="You have no upcoming leave" />
                );
            }
        } else if (this.props.person && this.props.person.Id && this.props.person.leaveApplications && this.props.person.leaveApplications.error) {
            error = heading; 
        } else {
            initialLoading = true;
        }

       

        return (
            <PageSection
                id="next-leave-widget"
                backgroundColor={backgroundColor} 
            >
                <List
                    icon="icon-next-leave"
                    id={this.props.id}
                    heading={heading}
                    hasColoredBackground={backgroundColor}
                    link={link}
                    loading={initialLoading}
                    error={error}
                >
                    <ListSection>
                        {nextLeaveContent}   
                    </ListSection>
                </List>     
            </PageSection>
        );
    }
}

NextLeaveWidget.propTypes = propTypes;

export default NextLeaveWidget; 
